
import { hideAllPoppers } from 'floating-vue';

export default {
  name: 'Sort',
  data() {
    return {
      selected: null,
      direction: 'asc',
      emittedValue: null,
    };
  },
  props: {
    value: {
      type: String | null,
      required: true,
    },
    filter: {
      type: Object,
      required: true,
    },
  },
  methods: {
    bubbleUp(val) {
      this.emittedValue = val.value;
      if (this.direction === 'desc') {
        this.$emit('input', '-' + this.emittedValue);
      } else {
        this.$emit('input', this.emittedValue);
      }

      this.hideAll();
    },
    setDirection(dir) {
      this.direction = dir;
      this.bubbleUp(this.selected);
    },
    hideAll() {
      hideAllPoppers();
    },
  },
  computed: {
    isDirty() {
      return this.emittedValue;
    },
    visibleText() {
      let text = this.selected.label;

      if (text.includes('pinned_conversations')) {
        text = text.replace('pinned_conversations,', '');
      }
      if (text.includes('latest_message')) {
        text = text.replace(/,-?created_at/, '');
      }
      return text.replace('-', '');
    },

    availableOptions() {
      // if an array make objects with value/label
      if (this.filter.options.length > 0) {
        if (typeof this.filter.options[0] === 'string') {
          return this.filter.options.map((opt) => ({
            value: opt,
            label: this.$helpers.sentencify(opt),
          }));
        }
      }
      // If already array of objects, return as is
      return this.filter.options;
    },
    strippedOption() {
      return this.selected.value;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        let options = this.availableOptions;
        if (val === null || val === undefined) {
          let object = options.find((option) => option.value === this.filter.default);
          this.emittedValue = this.filter.default;
          this.selected = object;
          this.bubbleUp(this.selected);
        } else {
          let searchVal = val.startsWith('-') ? val.slice(1) : val;
          let object = options.find((option) => option.value === searchVal);
          this.selected = object;
          this.emittedValue = val;
          if (val.startsWith('-')) {
            this.direction = 'desc';
          } else {
            this.direction = 'asc';
          }
        }
      },
    },
  },
};
